// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._syaz1fxt{color:var(--ds-text,#172b4d)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlassian/search-ai/node_modules/@atlaskit/smart-card/dist/esm/view/BlockCard/views/NotFoundView.compiled.css"],"names":[],"mappings":"AAAA,WAAW,4BAA4B","sourcesContent":["._syaz1fxt{color:var(--ds-text,#172b4d)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
